<form clrStepper  [formGroup]="orderForm">
  <clr-stepper-panel formGroupName="stepI">
    <clr-step-title>Lieferant</clr-step-title>
    <clr-step-description>Name, Kurzbeschreibung, Zeitraum</clr-step-description>
    <clr-step-content *clrIfExpanded>

      <clr-input-container>
        <label>Betreff</label>
        <input clrInput name="order_subject" formControlName="order_subject" />
        <clr-control-error *clrIfError="'required'">Ein Betreff muss angegeben werden</clr-control-error>
        <clr-control-error *clrIfError="'maxLength'; error as err">Betreff zu lang (max. {{ err.name_projectLenght}} Zeichen)</clr-control-error>
      </clr-input-container>

      <clr-input-container>
        <label>Zulieferer</label>
        <input clrInput name="company_name" formControlName="company_name" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput formControlName="order_street" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput formControlName="order_city" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput formControlName="order_postcode" />
      </clr-input-container>
      <app-country-select controlName="order_country" label="Land" />
      <clr-select-container *ngIf="isUpdateMode">
        <label>Status</label>
        <select clrSelect formControlName="order_status" required>
          <option value="open" selected>Entwurf</option>
          <option value="shipped" selected>Abgeschickt</option>
          <option value="confirmed">Bestätigt</option>
          <option value="running">In Arbeit</option>
          <option value="storno">Storniert</option>
          <option value="invoiced">Berechnet</option>
          <option value="done">Erledigt</option>
        </select>
        <clr-control-error>Statusupdate nicht vergessen!</clr-control-error>
      </clr-select-container>
      <clr-input-container *ngIf="(orderForm.value.stepI.order_status === 'confirmed') || (orderForm.value.stepI.order_status === 'running') || (orderForm.value.stepI.order_status === 'invoiced') || (orderForm.value.stepI.order_status === 'done') ">
        <label>Auftragsbestätigungsnummer des Auftragnehmers</label>
        <input clrInput formControlName="order_confirmation_id" />
      </clr-input-container>
      <clr-date-container>
        <label>Datum</label>
        <input clrDate type="date" placeholder="{{ ordersData?.order_date | date: 'dd.MM.yyyy' }}" formControlName="order_date" />
      </clr-date-container>
      <clr-date-container>
        <label>Lieferdatum</label>
        <input clrDate type="date" placeholder="{{ ordersData?.order_delivery | date: 'dd.MM.yyyy' }}" formControlName="order_delivery" />
      </clr-date-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="orderForm.invalid">Weiter</button>
        <button class="btn btn-danger" *ngIf="!isUpdateMode" (click)="deleteOrder()">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/order/details', projectId, orderId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepII">
    <clr-step-title>Bearbeiter</clr-step-title>
    <clr-step-description>(seitens PPS - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content *clrIfExpanded>
      <div *ngIf="devMode">Bearbeiter {{ projectStaff() }}</div>

      <clr-radio-container clrInline>
        <clr-radio-wrapper *ngFor="let employee of staff">
          <input *ngIf="employee.staff_id !== projectStaff()" type="radio" clrRadio formControlName="employee_phm" value="{{ employee.staff_id }}" />
          <label *ngIf="employee.staff_id !== projectStaff()">{{ employee.firstname }} {{ employee.lastname }}</label>
          <label *ngIf="employee.staff_id === projectStaff()" class="leader"><b>{{ employee.firstname }} {{ employee.lastname }}</b></label>
        </clr-radio-wrapper>
      </clr-radio-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="orderForm.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/order/details', projectId, orderId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIII">
    <clr-step-title>Ansprechpartner</clr-step-title>
    <clr-step-description>(seitens Kunden - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content *clrIfExpanded>
      <div *ngIf="devMode">Ansprechpartner {{ ordersData?.person_delivery }}</div>
      <select clrSelect formControlName="employee_order">
        <option></option>
        <option *ngFor="let person of persons" value="{{ person.pid }}">{{ person.lastname }}, {{ person.firstname }}</option>
      </select>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="orderForm.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" [routerLink]="['/order/details', projectId, orderId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIV">
    <clr-step-title>Bedingungen</clr-step-title>
    <clr-step-description>(seitens PPS - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content *clrIfExpanded>
      <div *ngIf="devMode">Lieferbedingungen {{ orderForm.value.stepIV.cond_delivery }} Zahlungsbedingungen {{ orderForm.value.stepIV.cond_payment }} </div>
      <br>
      <label>Lieferbedingungen: </label>
      <select clrSelect formControlName="cond_delivery">
        <option></option>
        <option *ngFor="let condI of delivery_conditions" value="{{ condI.cond_id }}">{{ condI.name }} ({{ condI.text }})</option>
      </select>
      <br />
      <label>Zahlungsbedingungen: </label>
      <select clrSelect formControlName="cond_payment">
        <option></option>
        <option *ngFor="let condII of payment_conditions" value="{{ condII.cond_id }}">{{ condII.name }}</option>
      </select>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="submit" [disabled]="orderForm.invalid" *ngIf="!selectedDeliveryHasOption" (click)="updateOrder()">Änderungen speichern</button>
        <button class="btn" clrStepButton="next" *ngIf="selectedDeliveryHasOption">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" [routerLink]="['/order/details', projectId, orderId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel *ngIf="selectedDeliveryHasOption" formGroupName="stepV">
    <clr-step-title>Abweichende Lieferanschrift</clr-step-title>
    <clr-step-description>(seitens Kunden nur bei DAP)</clr-step-description>
    <clr-step-content *clrIfExpanded>

      <app-request-company-search (submitSupplierNumber)="fillRecipient($event)"></app-request-company-search>

      <br /><br />
      <ng-container *ngIf="delivery_address.length > 0">
        {{ delivery_address[0].company }}<br />
        {{ delivery_address[0].street }}<br />
        {{ delivery_address[0].postcode }} {{ delivery_address[0].city }}<br />
        {{ delivery_address[0].country }}<br />
      </ng-container>
      <br />

      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="submit" [disabled]="orderForm.invalid" (click)="updateOrder()">Speichern</button>
        <button class="btn btn-warning-outline btn-sm" [routerLink]="['/order/details', projectId, orderId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>
</form>

<pre *ngIf="devMode" class="datepicker-output">
    {{ orderForm.value | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
    {{ ordersData | json }}
</pre>
